import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeader";
import PopupConfirmation from "../../client/third-party-casino/popup-confirmation";
import { useNavigate, Link } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";

//import "../../../assets/css/tp-style/Betprogames.css";

export default function WorldCasino() {
  const [balance, setBalance] = useState(0);
  const [username, setUsername] = useState("");
  const [expouser, setExpouser] = useState(0);
  const [showRules, setShowRules] = useState(true);
  const navigate = useNavigate();

  const [launchURL, setLaunchURL] = useState("");

  const userInfo = useSelector((state) => state.userStore);

  useEffect(() => {
    setUsername(userInfo.data.uname);
    setBalance(parseInt(userInfo.data.bz_balance));
    setExpouser(parseInt(userInfo.data.opin_bal - userInfo.data.bz_balance));
    //}
  }, [userInfo, setUsername, setExpouser, setBalance]);

  const callBackend = async () => {
    let postData = JSON.stringify({
      providerCode: "SN",
      gameCode: ""
    });

    try {
      const response = await axiosInstance.post(
        "/th-casino/world-casino",
        postData
      );

      setLaunchURL(response.data.launchURL);
      console.log("response-launchURL->", response.data);
    } catch (error) {
      console.error("Error updating password:", error);
      //alert("Failed to update password.");
    } finally {
      //setSubmitting(false);
    }
  };

  const closeBetSlip = (action) => {
    setShowRules(false);
    if (!action) {
      navigate("/home");
    }
  };

  useEffect(() => {
    callBackend();
  }, []);

  return (
    <ClientLayoutWithOutHeader showLoader={false}>
      <style>{`  
          .home-section {
            position: relative;
            height: 100vh;
            left: 0;
            background:white;

            width: calc(100% - 0px);
            transition: all 0.1s ease;
        }  

`}</style>
      <section class="home-section">
        <div class="bodyheight">
          <div
            style={{ height: "100vh", width: "100%", background: "#121334" }}
          >
            <iframe
              class="iframetemplate"
              src={launchURL}
              style={{ width: "100%", height: "100vh", border: "0px" }}
            ></iframe>
          </div>
        </div>
      </section>

      <PopupConfirmation closeBetSlipParent={closeBetSlip} show={showRules} />
    </ClientLayoutWithOutHeader>
  );
}
